import { Guard } from '../../../../common/guards/guard';
import { LogManager } from '../../../../common/port/log/log.manager.port';
import { TeamMetricsCalendarViewsSummaryAggregateRootMapper } from '../../../../infrastructure/mappers/team-metrics/calendar/team-metrics-calendar-views-summary.aggregate-root.mapper';
import { GetTeamMetricsCalendarViewsSummaryRequestDto } from '../../../dtos/team-metrics/calendar/get-team-metrics-calendar-views-summary.request.dto';
import { GetTeamMetricsCalendarViewsSummaryResponseDto } from '../../../dtos/team-metrics/calendar/get-team-metrics-calendar-views-summary.response.dto';
import { GetTeamMetricsCalendarViewsSummaryQuery } from '../../../queries/team-metrics/calendar/get-team-metrics-calendar-views-summary.query';

export class GetTeamMetricsCalendarViewsSummaryController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetTeamMetricsCalendarViewsSummaryQuery,
    protected readonly mapper: TeamMetricsCalendarViewsSummaryAggregateRootMapper
  ) {}

  async get(
    props: GetTeamMetricsCalendarViewsSummaryRequestDto
  ): Promise<GetTeamMetricsCalendarViewsSummaryResponseDto> {
    try {
      const { segment, granularity } = props.params;
      const isGranularityEmpty = Guard.isEmpty(granularity);
      const isSegmentEmpty = Guard.isEmpty(segment);

      if (!isGranularityEmpty && !isSegmentEmpty) {
        throw new Error(
          'Cannot provide both granularity and weekday parameters'
        );
      }

      if (isGranularityEmpty && isSegmentEmpty) {
        throw new Error('No granularity or weekday parameters provided');
      }

      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `GetTeamMetricsCalendarViewsSummaryController.get encountered an error ${error}`
      );
    }
  }
}
